import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "firstname",
  standalone: false
})
export class FirstNamePipe implements PipeTransform {
  transform(str: any): any {
    return typeof str === "string" ? str.replace(/^\s*(\S*).*$/, "$1") : str;
  }
}
